"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.HealthCheckModel = void 0;
const core_1 = require("@veeam/core");
require("../types");
class HealthCheckModel extends core_1.Model {
    constructor(initialValue) {
        super(initialValue);
        this.updateModel = (newModelValue) => {
            this.update((modelValue) => {
                modelValue.isEnabled = newModelValue.isEnabled;
                modelValue.fieldDayNumberInMonthValue = newModelValue.fieldDayNumberInMonthValue;
                modelValue.fieldDayOfWeekValue = newModelValue.fieldDayOfWeekValue;
                modelValue.fieldDayOfMonthValue = newModelValue.fieldDayOfMonthValue;
                modelValue.fieldMonthValue = newModelValue.fieldMonthValue;
            });
        };
    }
}
exports.HealthCheckModel = HealthCheckModel;
//# sourceMappingURL=HealthCheckModel.js.map